import { Tooltip } from '@mui/material';
import InputOutlinedIcon from '@mui/icons-material/InputOutlined';
import { useTranslation } from 'react-i18next';

// Known `legacy_source` tags (#2394). Anything else falls back to a generic label.
const SOURCE_LABEL_KEYS: Record<string, string> = {
  innovoice: 'legacySource.innovoice',
};

interface LegacySourceIconProps {
  /** `legacy_source` of the row; nothing is drawn when it is empty. */
  source: string | null | undefined;
}

/** Marks a list row imported from a previous system (#3366). */
export function LegacySourceIcon({ source }: LegacySourceIconProps) {
  const { t } = useTranslation('common');
  if (!source) return null;

  const label = t(SOURCE_LABEL_KEYS[source] ?? 'legacySource.unknown');
  return (
    <Tooltip title={label}>
      <InputOutlinedIcon fontSize="small" color="action" titleAccess={label} sx={{ verticalAlign: 'middle' }} />
    </Tooltip>
  );
}
